import { createAppSlice } from '@exp/redux/createAppSlice';

import { getCampaignAssetData } from '../../js/common/api';

const initialState = {
  fetchPending: false,
  lastUpdateTime: null,
  campaignId: null,
  type: '',
  targetingType: '',
  name: '',
  headline: '',
  description: '',
  assetUuid: '',
  assetAnchorPosition: '',
  publishedDate: null,
  visitStoreCta: '',
  heroImageUrl: '',
  cardImageUrl: '',
  campaignHomeLinkUrl: '',
  orgId: null,
  orgName: '',
  orgAvatarImageUrl: '',
  orgKey: '',
};

const campaignAssetReducer = createAppSlice({
  name: 'campaignAsset',
  initialState,
  reducers: (create) => ({
    fetchCampaignAssetData: create.asyncThunk(
      (campaignId) => getCampaignAssetData(campaignId),
      {
        pending: (state) => { state.fetchPending = true; },
        fulfilled: (state, action) => {
          const d = action.payload.data;
          state.fetchPending = false;
          state.lastUpdateTime = Date.now();
          state.campaignId = d.campaignId;
          state.type = d.type;
          state.targetingType = d.targetingType;
          state.name = d.name;
          state.headline = d.headline;
          state.description = d.description;
          state.assetUuid = d.assetUuid;
          state.assetAnchorPosition = d.assetAnchorPosition;
          state.publishedDate = d.publishedDate;
          state.visitStoreCta = d.visitStoreCta;
          state.heroImageUrl = d.heroImageUrl;
          state.cardImageUrl = d.cardImageUrl;
          state.campaignHomeLinkUrl = d.campaignHomeLinkUrl;
          state.orgId = d.orgId;
          state.orgName = d.orgName;
          state.orgAvatarImageUrl = d.orgAvatarImageUrl;
          state.orgKey = d.orgKey;
        },
        rejected: (state) => {
          state.fetchPending = false;
          state.lastUpdateTime = null;
        },
      },
    ),
  }),
});

export const { fetchCampaignAssetData } = campaignAssetReducer.actions;
export default campaignAssetReducer.reducer;
